






































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'BaseInput',
  inheritAttrs: false
})
export default class BaseInput extends Vue {
  @Prop({
    type: [ String, Number ],
    required: true
  })
  private value!: string | number;

  @Prop({
    type: String,
    default: ''
  })
  private label!: string;

  @Prop({
    type: String,
    default: ''
  })
  private labelClass!: string;

  @Prop({
    type: Boolean,
    default: false
  })
  private isDone!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  private isError!: boolean;

  @Prop({
    type: Boolean,
    default: false
  })
  private disabled!: boolean;

  private isFocusedInput: boolean = false;

  private get inputListeners() {
    return Object.assign(
      {},
      this.$listeners,
      {
        input: this.handleInputEvent,
        focus: this.handleFocusEvent,
        blur: this.handleBlurEvent
      }
    );
  }

  private get labelClasses() {
    if (this.isFocusedInput) {
      return this.labelClass;
    }

    return {
      'jrm-input-sts-done': this.isDone,
      'jrm-input-sts-error': this.isError,
      [this.labelClass]: true
    };
  }

  public focus() {
    const input = <any> this.$refs.input;
    input.focus();
  }

  private handleInputEvent(event: any) {
    this.$emit('input', event.target.value);
  }

  private handleFocusEvent() {
    this.isFocusedInput = true;
  }

  private handleBlurEvent() {
    this.isFocusedInput = false;
  }
}
